import styled from 'styled-components/macro';
import { column, row } from 'src/App/Styles/styles-helpers';
import { GlobalColors } from 'src/App/Styles/Globals';
import { row_center_both } from 'src/App/Styles/styles-helpers';

export const LeaderboardContain = styled.div`
	padding: 1em;
	padding-bottom: 0;
	${column}
	flex:1;
	gap: 1em;
	overflow: hidden;
`;
export const LeaderboardTabWrapper = styled.div`
	${row_center_both}
	gap: 40px;
`;
export const LeaderboardTabItem = styled.div<{ selected: boolean }>`
	cursor: pointer;
	height: 100%;
	font-size: 0.875rem;
	font-weight: bold;
	padding: 1rem 0;
	flex: 1;
	${row_center_both}
	color: ${({ selected }) => (selected ? GlobalColors.pinkSamen : GlobalColors.activeTabs)};
	transition: 0.3s;
	&:hover {
		opacity: 0.7;
	}
`;
